<template src="./template.html"></template>

<script>
  // import { mapActions, mapState } from 'vuex'

  export default {
    name: 'DummyPage',
    metaInfo() {
      return {
        title: 'Dummy',
        titleTemplate: this.$t('meta.sub_title', { title: '%s' }),
      }
    },
    components: {
      ComponentLoader: () => import('@/components/modules/ComponentLoader'),
    },
    data() {
      return {
        profilesData: {
          options: {
            'order_by': null,
            'title': 'ALLE TRAINER IM ÜBERBLICK',
            'filters': {
              'profileteaser': true,
              'location': [],
              'position': [],
              'section': [],
              'specialstate': [],
            },
            'pagination': {
              'limit': 9,
              'self': 1,
              'first': 1,
              'prev': '',
              'next': 2,
              'last': 2,
            },
          },
          'results': {
            'users': [
              {
                'id': 2379,
                'username': 'anmoll',
                'profile_url': '/profile/2379',
                'firstname': 'Andreas',
                'lastname': 'Moll',
                'image': '/api/v2/media/content/det/38/54/img105438.jpg',
                'title': 'F\u0026B Manager',
                'location_names': [ 'München-Campus' ],
                'special_tasks': [
                  'One University Expert',
                  'ADA Ausbilderschein',
                ],
                'occasions': [
                  {
                    'type': 'birthday',
                    'date': '2020-08-27',
                  },
                ],
              },
              {
                'id': 3971,
                'username': 'bebader',
                'profile_url': '/profile/3971',
                'firstname': 'Benjamin',
                'lastname': 'Bader',
                'image': '/api/v2/media/content/det/16/61/img106116.jpg',
                'title': 'Director Training',
                'location_names': [ 'München-Head Office' ],
                'special_tasks': [ 'One University Expert' ],
                'occasions': [],
              },
              {
                'id': 1387,
                'username': 'brzienert',
                'profile_url': '/profile/1387',
                'firstname': 'Brigitte',
                'lastname': 'Zienert',
                'image': '/api/v2/media/content/det/76/49/img104976.jpg',
                'title': 'Reservation Manager',
                'location_names': [ 'München-Campus' ],
                'special_tasks': [ 'One University Expert' ],
                'occasions': [
                  {
                    'type': 'birthday',
                    'date': '2020-07-18',
                  },
                ],
              },
              {
                'id': 5507,
                'username': 'hiopitz',
                'profile_url': '/profile/5507',
                'firstname': 'Hilke',
                'lastname': 'Opitz',
                'image': '/api/v2/media/content/det/73/69/img106973.jpg',
                'title': 'Trainer',
                'location_names': [ 'München-Head Office' ],
                'special_tasks': [ 'One University Expert' ],
                'occasions': [],
              },
              {
                'id': 2858,
                'username': 'kalepold',
                'profile_url': '/profile/2858',
                'firstname': 'Katrin',
                'lastname': 'Lepold',
                'image': '/api/v2/media/content/det/34/56/img105634.jpg',
                'title': 'Manager Human Relations',
                'location_names': [ 'München-Head Office' ],
                'special_tasks': [
                  'My One Expert',
                  'One University Expert',
                ],
                'occasions': [],
              },
              {
                'id': 10,
                'username': 'kewinkelmann',
                'profile_url': '/profile/10',
                'firstname': 'Kerstin',
                'lastname': 'Winkelmann',
                'image': '/api/v2/media/content/det/91/47/img104791.jpg',
                'title': 'Head of Human Relations',
                'location_names': [ 'München-Head Office' ],
                'special_tasks': [
                  'ADA Ausbilderschein',
                  'WIKI Expert',
                  'Coaching Expert',
                  'One University Expert',
                  'Ersthelfer',
                  'Bar Expert',
                  'My One Expert',
                  'Sihot Expert',
                  'Dressmanager',
                  'FDC',
                ],
                'occasions': [
                  {
                    'type': 'birthday',
                    'date': '2020-12-26',
                  },
                ],
              },
              {
                'id': 5109,
                'username': 'kokonstantos_2',
                'profile_url': '/profile/5109',
                'firstname': 'Konstantinos ',
                'lastname': 'Konstantos',
                'image': '/api/v2/media/content/det/59/67/img106759.jpg',
                'title': 'F\u0026B Manager',
                'location_names': [ 'Amsterdam-Waterlooplein' ],
                'special_tasks': [
                  'Coaching Expert',
                  'One University Expert',
                  'Bar Expert',
                  'My One Expert',
                ],
                'occasions': [
                  {
                    'type': 'birthday',
                    'date': '2020-08-25',
                  },
                ],
              },
              {
                'id': 5092,
                'username': 'natreziak',
                'profile_url': '/profile/5092',
                'firstname': 'Natalia Weronika ',
                'lastname': 'Trzeciak',
                'image': '/api/v2/media/user-image-not-found.jpg',
                'title': 'Front Office \u0026 Reservation Manager',
                'location_names': [ 'Amsterdam-Waterlooplein' ],
                'special_tasks': [
                  'WIKI Expert',
                  'Coaching Expert',
                  'One University Expert',
                  'Ersthelfer',
                  'Sihot Expert',
                  'My One Expert',
                ],
                'occasions': [],
              },
              {
                'id': 5000,
                'username': 'nivan-tongeren',
                'profile_url': '/profile/5000',
                'firstname': 'Nikki ',
                'lastname': 'van Tongeren',
                'image': '/api/v2/media/content/det/95/66/img106695.png',
                'title': 'Sales Manager',
                'location_names': [ 'Amsterdam-Waterlooplein' ],
                'special_tasks': [
                  'One University Expert',
                  'Ersthelfer',
                  'My One Expert',
                  'Dressmanager',
                ],
                'occasions': [],
              },
            ],
            'options': {},
          },
        },
        shopmodule: {
          results: [
            {
              name: 'Test',
              image: 'https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg',
              price: 10,
            },
            {
              name: 'Test2',
              image: 'https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg',
              price: 100,
            },
            {
              name: 'Test3',
              image: 'https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg',
              price: 0,
            },
            {
              name: 'Test4',
              image: 'https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg',
              price: 1000,
            },
          ],
          options: {
            title: 'Es warten tolle Prämien auf dich!',
          },
        },
        galleryData: {
          results: [
            'https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg',
            'https://cdn.pixabay.com/photo/2015/02/24/15/41/dog-647528__340.jpg',
            'https://image.freepik.com/free-photo/tropical-leaves-colorful-flower-dark-tropical-foliage-nature-background-darkest-green-foliage_34998-128.jpg',
            'https://via.placeholder.com/468x60',
          ],
          options: {
            title: 'Gallery Module',
          },
        },
        downloadData: {
          results: [
            {
              image: 'https://blob.vivotek.com/downloadfile/api/LandingPages/Downloads/icon-download-product-files.png',
              title: 'Abmahnung wg Zuspaetkommen',
              type: 'DOCX',
              size: '36 Bytes',
              linkToDownload: 'test',
            },
            {
              image: 'https://blob.vivotek.com/downloadfile/api/LandingPages/Downloads/icon-download-product-files.png',
              title: 'Abmahnung wg Zuspaetkommen',
              type: 'DOCX',
              size: '36 Bytes',
              linkToDownload: 'test',
            },
            {
              image: 'https://blob.vivotek.com/downloadfile/api/LandingPages/Downloads/icon-download-product-files.png',
              title: 'Abmahnung wg Zuspaetkommen',
              type: 'DOCX',
              size: '36 Bytes',
              linkToDownload: 'test',
            },
            {
              image: 'https://blob.vivotek.com/downloadfile/api/LandingPages/Downloads/icon-download-product-files.png',
              title: 'Abmahnung wg Zuspaetkommen',
              type: 'DOCX',
              size: '36 Bytes',
              linkToDownload: 'test',
            },
          ],
          options: {
            title: 'Downloads',
          },
        },
        navigationSubpages: {
          results: [
            {
              icon: '',
              title: 'Arbeitsrechtliche Regelungen',
              link: '',
            },
            {
              icon: 'mdi-clipboard',
              title: 'Arbeitssicherheit',
              link: '',
            },
            {
              icon: 'mdi-school-outline',
              title: 'Duales Studium',
              link: '',
            },
            {
              icon: '',
              title: 'Externe Dienstleister / Externe Mitarbeiter',
              link: '',
            },
            {
              icon: '',
              title: 'Incentive System',
              link: '',
            },
            {
              icon: '',
              title: 'Meeting & Events',
              link: '',
            },
            {
              icon: '',
              title: 'My One',
              link: '',
            },
            {
              icon: '',
              title: 'Onboarding',
              link: '',
            },
          ],
          options: {
            title: 'Themen im Bereich Human Relations',
          },
        },
        wysiwygContent: {
          results: '<table class="tbl-A">\n' +
                   '          <thead>\n' +
                   '          <tr>\n' +
                   '          <th>1</th>\n' +
                   '          <th>2</th>\n' +
                   '          <th>3</th>\n' +
                   '          <th>4</th>\n' +
                   '          </tr>\n' +
                   '          </thead>\n' +
                   '          <tbody>\n' +
                   '          <tr>\n' +
                   '          <th><span>11</span></th>\n' +
                   '        <th><span>222</span></th>\n' +
                   '      <th><span>3333</span></th>\n' +
                   '      <th><span>44444</span></th>\n' +
                   '      </tr>\n' +
                   '      <tr>\n' +
                   '      <th><span>11</span></th>\n' +
                   '      <th><span>222</span></th>\n' +
                   '      <th><span>3333</span></th>\n' +
                   '      <th><span>44444</span></th>\n' +
                   '      </tr>\n' +
                   '      </tbody>\n' +
                   '      </table>' +
                   '<iframe src="https://www.youtube.com/embed/gaiR9MLryqU" frameborder="0" allowfullscreen="allowfullscreen"></iframe>' +
                   '\n\n\n' +
                   '<p><iframe src="//www.youtube.com/embed/Lg3S4KOewuY" frameborder="0" allowfullscreen="allowfullscreen" style="width: calc(100% + 106px); height: 400px; margin-left: -53px; margin-top: -25px; margin-bottom: -20px;"></iframe></p>',
        },
        coachingsData: {
          results: [
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.001 AUSQUARTIERUNG',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.002 RÜCKZAHLUNG',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.003 CHECK-IN',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.004 LOREM IPSUM',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.005 LOREM IPSUM DOLOR SIT',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.006 LOREM IPSUM',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.007 LOREM IPSUM',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.008 LOREM IPSUM DOLOR SIT',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.009 LOREM IPSUM',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.010 LOREM IPSUM DOLOR SIT',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.001 AUSQUARTIERUNG',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.002 RÜCKZAHLUNG',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.003 CHECK-IN',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.004 LOREM IPSUM',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.005 LOREM IPSUM DOLOR SIT',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.006 LOREM IPSUM',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.007 LOREM IPSUM',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.008 LOREM IPSUM DOLOR SIT',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.009 LOREM IPSUM',
              link: 'http://test_link.com',
            },
            {
              page_name: 'FRONT OFFICE',
              article_name: 'FO.010 LOREM IPSUM DOLOR SIT',
              link: 'http://test_link.com',
            },
          ],
          options: {
            title: '',
          },
        },
        gympassData: {
          results: 'http://linktogympass.com/?user_id=123123',
        },
        articleData: {
          'results': {
            'title': 'ALLGEMEINE INFORMATIONEN',
            'description': '',
            'template': 'article',
            'intervall': '5',
            'autoplay': '0',
            'teasers': [
              {
                'id': 'page-14026',
                'title': 'Zuständigkeiten Human Relations ',
                'teaser': 'Hier finden Sie die Zuständigkeiten des Human Relations Teams.',
                'content': '',
                'publish_date': '2019-09-26 11:41:00',
                'author': {
                  'name': 'Stefan Lipperheide',
                  'avatar': '/api/v2/media/content/det/86/47/img104786.png',
                },
                'images': {
                  'title': {
                    'type': 'image/jpeg',
                    'link': '/api/v2/media/content/orig/10/16/img121610.jpg',
                  },
                  'slider': null,
                  'teaser': null,
                  'images': [],
                },
                'attachments': [
                  {
                    'type': 'image/jpeg',
                    'link': '/api/v2/media/content/orig/10/16/img121610.jpg',
                  },
                ],
              },
              {
                'id': 'page-14013',
                'title': 'Zuständigkeiten Marketing \u0026 E-Commerce',
                'teaser': 'Hier finden Sie die Zuständigkeiten des Marketing \u0026 E-Commerce Teams.',
                'content': '',
                'publish_date': '2019-07-19 11:26:00',
                'author': {
                  'name': 'Anythingabout Testuser',
                  'avatar': '/api/v2/media/user-image-not-found.jpg',
                },
                'images': {
                  'title': {
                    'type': 'image/jpeg',
                    'link': '/api/v2/media/content/orig/56/14/img121456.jpg',
                  },
                  'slider': null,
                  'teaser': null,
                  'images': [],
                },
                'attachments': [
                  {
                    'type': 'image/jpeg',
                    'link': '/api/v2/media/content/orig/56/14/img121456.jpg',
                  },
                ],
              },
              {
                'id': 'page-13304',
                'title': 'Die Historie von Motel One Apeksh Apeksh apEKSH aPWTJKNJFKG',
                'teaser': 'Lesen Sie hier wie alles begann... ',
                'content': '\u003cdiv class="row module"\u003e\r\n\u003cdiv class="article-content"\u003e\r\n\u003cp\u003e\u003cstrong\u003e1999\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eDie Idee zu Motel One reift beim Fr\u0026uuml;hst\u0026uuml;ck zwischen Dieter M\u0026uuml;ller und Philippe Weyland in einem kleinen Caf\u0026eacute; in Haidhausen.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2000\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eDas erste Motel One wird in Frankfurt-Offenbach er\u0026ouml;ffnet.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2003\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eMotel One zieht es in die Innenst\u0026auml;dte.\u003c/li\u003e\r\n\u003cli\u003eDas Motel One Berlin-Mitte er\u0026ouml;ffnet.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2005\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eDas Motel One Design Konzept wird entwickelt.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2006\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eIn N\u0026uuml;rnberg und Hamburg zieht erstmals der t\u0026uuml;rkise Egg Chair ein und die ersten One Lounges laden zum Entspannen ein.\u003c/li\u003e\r\n\u003cli\u003eKlare Positionierung als Low Budget Design Hotel \u0026rarr; Motel One nimmt damit eine Pionierrolle in Deutschland ein.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2009\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eGr\u0026uuml;nder und \u003cspan\u003eCEO\u003c/span\u003e Dieter M\u0026uuml;ller wird \u0026bdquo;Hotelier des Jahres\u0026ldquo;.\u003c/li\u003e\r\n\u003cli\u003eMotel One w\u0026auml;chst: mehr als 4.400 Motel One Zimmer sind nun in Betrieb.\u003c/li\u003e\r\n\u003cli\u003eDas neue Motel One Logodesign entsteht.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2010\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eMotel One ist \u0026ldquo;Bestes Budget Hotel Deutschlands\u0026ldquo; (laut dem Deutschen Institut f\u0026uuml;r Service-Qualit\u0026auml;t im Auftrag von n-tv).\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2011\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eEr\u0026ouml;ffnung der ersten Motel One in \u0026Ouml;sterreich, in Salzburg und Wien.\u003c/li\u003e\r\n\u003cli\u003e\u0026Uuml;ber 8.000 Zimmer in Betrieb und rund 1.000 Mitarbeiter besch\u0026auml;ftigt.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2012\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eEr\u0026ouml;ffnung des ersten Motel One in UK, Motel One Edinburgh-Royal.\u003c/li\u003e\r\n\u003cli\u003eErstmals \u0026uuml;ber 3 Millionen G\u0026auml;ste in 42 Motel One.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2013\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eIm Motel One Wien-Prater wird das 10.000 Motel One Zimmer er\u0026ouml;ffnet, das Zimmer Nr. 538 (siehe Bild oben).\u003c/li\u003e\r\n\u003cli\u003eRund 1.300 Mitarbeiter sind nun f\u0026uuml;r unsere G\u0026auml;ste da.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2014\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eMotel One wird erneut zum \u0026bdquo;Besten Budget Hotel Deutschlands\u0026ldquo; gew\u0026auml;hlt.\u003c/li\u003e\r\n\u003cli\u003eMotel One er\u0026ouml;ffnet das erste Hotel in Belgien, in Br\u0026uuml;ssel.\u003c/li\u003e\r\n\u003cli\u003eAm neuen Motel One Campus startet die erste duale Studienklasse.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2015\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eMarkteintritt in Tschechien und Holland: das Motel One Prag und das Motel One Amsterdam er\u0026ouml;ffnen.\u003c/li\u003e\r\n\u003cli\u003eMotel One erh\u0026auml;lt den prestigetr\u0026auml;chtigen \u0026ldquo;Deutschen Marketing Preis\u0026rdquo; \u0026ndash; als erste Hotel Marke.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2016\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eMit dem Motel One Basel er\u0026ouml;ffnet das erste Motel One in der Schweiz.\u003c/li\u003e\r\n\u003cli\u003eMotel One erh\u0026auml;lt zum wiederholten male die Auszeichnung \u0026ldquo;Bestes Budget Hotel Deutschlands\u0026rdquo; und wird von Ernst \u0026amp; Young zum \u0026ldquo;Entrepreneur of the Year\u0026rdquo; gew\u0026auml;hlt.\u003c/li\u003e\r\n\u003cli\u003eDieter M\u0026uuml;ller erh\u0026auml;lt den \u003cspan\u003eIHIF\u003c/span\u003e Lifetime Achievement Award, den Oskar der Hotel Branche.\u003c/li\u003e\r\n\u003cli\u003eIm Jahr 2016 begr\u0026uuml;\u0026szlig;t Motel One 5,4 Millionen G\u0026auml;ste in 55 Hotels.\u003c/li\u003e\r\n\u003cli\u003eLaunch des neuen Claims: \u0026bdquo;Like the Price. Love the Design.\u0026ldquo;\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2017\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eNach rekordverd\u0026auml;chtigen acht Neuer\u0026ouml;ffnungen hat Motel One nun 63 Hotels mit 17.700 Zimmern in acht L\u0026auml;ndern in Betrieb.\u003c/li\u003e\r\n\u003cli\u003eDas Motel One Integrationsprojekt wird auf Berlin ausgeweitet.\u003c/li\u003e\r\n\u003cli\u003eMotel One erh\u0026auml;lt den German Brand Award.\u003c/li\u003e\r\n\u003cli\u003eDas digitale Membership Programm beOne wird gelauncht.\u003c/li\u003e\r\n\u003cli\u003eGr\u0026uuml;ndung der Stiftung One Foundation zur Unterst\u0026uuml;tzung benachteiligter Menschen.\u003c/li\u003e\r\n\u003cli\u003eMit dem Motel One Berlin-Upper West er\u0026ouml;ffnet Motel One das bisher gr\u0026ouml;\u0026szlig;te Haus mit 582 Zimmern auf 19 Stockwerken.\u003c/li\u003e\r\n\u003cli\u003eMotel One wird vom Magazin \u0026ldquo;Focus\u0026rdquo; in Zusammenarbeit mit Xing und kununu als \u0026ldquo;Top Nationaler Arbeitgeber\u0026rdquo; und vom Magazin \u0026ldquo;Brand Eins\u0026rdquo; als \u0026ldquo;Innovator of the Year\u0026rdquo; ausgezeichnet.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e2018\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eMotel One er\u0026ouml;ffnet mit dem Motel One Barcelona-Ciutadella das erste Hotel in Spanien und mit dem Motel One Paris-Porte Dor\u0026eacute;e das erste Hotel in Frankreich\u003c/li\u003e\r\n\u003cli\u003eMotel One wird mit dem renommierten Wirtschaftspreis Game Changer Award von Bain \u0026amp; Company und dem manager magazin ausgezeichnet.\u003c/li\u003e\r\n\u003cli\u003eMotel One f\u0026uuml;hrt mit dem \u0026bdquo;urban Bio Breakfast\u0026ldquo; in Deutschland und \u0026Ouml;sterreich ein neues Fr\u0026uuml;hst\u0026uuml;ckskonzept mit dem Fokus auf noch gr\u0026ouml;\u0026szlig;erer Bio-Produktauswahl ein.\u003c/li\u003e\r\n\u003cli\u003eDas digitale Membership-Programm beOne verbucht 304.000 registrierten Member.\u003c/li\u003e\r\n\u003cli\u003eMotel One verf\u0026uuml;gt \u0026uuml;ber 71 Hotels und 20.160 Zimmer in neun L\u0026auml;ndern.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003c/div\u003e\r\n\u003c/div\u003e',
                'publish_date': '2019-07-19 10:19:00',
                'author': {
                  'name': 'Anythingabout Testuser',
                  'avatar': '/api/v2/media/user-image-not-found.jpg',
                },
                'images': {
                  'title': {
                    'type': 'image/jpeg',
                    'link': '/api/v2/media/content/orig/58/86/img118658.jpg',
                  },
                  'slider': null,
                  'teaser': null,
                  'images': [],
                },
                'attachments': [
                  {
                    'type': 'image/jpeg',
                    'link': '/api/v2/media/content/orig/58/86/img118658.jpg',
                  },
                ],
              },
              {
                'id': 'page-13799',
                'title': 'Reiserichtlinien',
                'teaser': 'Eigenverantwortlichkeit ist ein wichtiger Bestandteil unserer Mitarbeiterphilosophie und als Wert fester Bestandteil der Motel One DNA.',
                'content': '\u003cdiv class="row module"\u003e\r\n\u003cdiv class="article-content"\u003e\r\n\u003cp\u003eWir transportieren nicht nur jeden Tag wichtige Eigenschaften eines Gastgebers wie Freundlichkeit und Servicebereitschaft, sondern sind auch verpflichtet wirtschaftlich und umweltbewusst zu handeln.\u003c/p\u003e\r\n\u003cp\u003eAus diesem Grunde finden Sie folgend die Motel One Richtlinien f\u0026uuml;r die effiziente und kosteng\u0026uuml;nstige Reiseplanung:\u003c/p\u003e\r\n\u003cp\u003e\u003cstrong\u003eBahnfahrten\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eGrunds\u0026auml;tzlich wird die 2.Klasse in der g\u0026uuml;nstigsten Variante gebucht. Ausnahmen m\u0026uuml;ssen vom jeweiligen Abteilungsleiter/Vorgesetzten genehmigt und begr\u0026uuml;ndet werden.\u003c/li\u003e\r\n\u003cli\u003eSitzplatzreservierung und Weiterfahrt mit den \u0026ouml;ffentlichen Verkehrsmitteln sind nach M\u0026ouml;glichkeit mit zu buchen. Das Reiseb\u0026uuml;ro bucht Ihnen auf Wunsch den Sitzplatz sowie die Fahrkarte f\u0026uuml;r die \u0026ouml;ffentlichen Verkehrsmittel am Ankunftsort mit und stellt eine Rechnung f\u0026uuml;r alle Leistungen zusammen aus. Das erleichtert auch die Reisekostenabrechnung.\u003c/li\u003e\r\n\u003cli\u003eDie Buchungen der Bahnfahrten sind fr\u0026uuml;hestm\u0026ouml;glich vorzunehmen, um die attraktivsten Preise zu erhalten. Dies ist f\u0026uuml;r Bahnfahrten ab 6 Monate im Voraus m\u0026ouml;glich.\u003c/li\u003e\r\n\u003cli\u003ePrivate Bahncards d\u0026uuml;rfen nicht f\u0026uuml;r Gesch\u0026auml;ftsreisen genutzt werden. Bahnreisen m\u0026uuml;ssen direkt \u0026uuml;ber unser Reiseb\u0026uuml;ro Intertours gebucht und ggf. auch storniert werden. Gesch\u0026auml;ftliche Vielfahrer k\u0026ouml;nnen bei nachgewiesener Wirtschaftlichkeit eine BahnCard 50 Business, 2. Klasse \u0026uuml;ber das Reiseb\u0026uuml;ro Intertours bestellen. Die Anschaffung dieser BahnCard muss vom Vorgesetzten genehmigt werden.\u003c/li\u003e\r\n\u003cli\u003eF\u0026uuml;r Bahnfahrten bis 500 Kilometer Fahrstrecke oder 5 Stunden Gesamtfahrzeit zum Zielort muss grunds\u0026auml;tzlich die 2. Klasse gebucht werden. Gem\u0026auml;\u0026szlig; dem Prinzip der Wirtschaftlichkeit darf alternativ die 1. Klasse gebucht werden, wenn diese auch unter Ber\u0026uuml;cksichtigung der inkludierten Leistungen g\u0026uuml;nstiger ist. Als Grundlage f\u0026uuml;r die Kontrolle muss zum Vergleich der Preis der zweiten Klasse auf der Auftragsbest\u0026auml;tigung von Reiseb\u0026uuml;ro aufgef\u0026uuml;hrt sein.\u003c/li\u003e\r\n\u003cli\u003eAb einer Fahrstrecke von 500 Kilometern kann f\u0026uuml;r alle Mitarbeiter die 1. Klasse gebucht werden. Zus\u0026auml;tzlich kann die Bahnreise mit der 1. Klasse in begr\u0026uuml;ndeten Fall vom Manager oder im Headoffice vom direkten Vorgesetzten schriftlich genehmigt werden.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003eMietwagen\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eMietwagen sollen f\u0026uuml;r Gesch\u0026auml;ftsreisen in Anspruch genommen werden, wenn der Mietwagen preisg\u0026uuml;nstiger als ein anderes Verkehrsmittel ist oder wenn die Benutzung \u0026ouml;ffentlicher Verkehrsmittel nicht m\u0026ouml;glich oder unwirtschaftlich ist. Dies gilt auch vor Ort am Reiseziel.\u003c/li\u003e\r\n\u003cli\u003eDie Buchung von Mietwagen erfolgt \u0026uuml;ber unser Firmenonlineportal von Sixt. Jedes Hotel hat eine Sixt Corporate Card und einen eigenen Buchungslink f\u0026uuml;r die direkte Anmietung bei Sixt auf Rechnung. Das Vertragsreiseb\u0026uuml;ro wird nicht involviert.\u003c/li\u003e\r\n\u003cli\u003eDie bevorzugte Fahrzeugklasse ist Mittelklasse (VW Golf-Klasse/CRMR). Ab 3 Personen kann eine h\u0026ouml;here Fahrzeugklasse (VW Passat \u0026ndash; Klasse/IWMR) genutzt werden.\u003c/li\u003e\r\n\u003cli\u003eBuchbare Versicherungen und Zusatzleistungen sind wie folgt definiert: Dieselfahrzeug (Pflicht), Personen-Unfall-Schutz\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003ePrivat-\u003cspan\u003ePKW\u003c/span\u003e\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eFahrten mit dem eigenem \u003cspan\u003ePKW\u003c/span\u003e sind nach M\u0026ouml;glichkeit zu vermeiden. Private Kraftfahrzeuge k\u0026ouml;nnen f\u0026uuml;r Gesch\u0026auml;ftsreisen genutzt werden, wenn \u0026ouml;ffentliche Verkehrsmittel oder Mietwagen aus zeitlichen, wirtschaftlichen oder anderen Gr\u0026uuml;nden nicht in Betracht kommen.\u003c/li\u003e\r\n\u003cli\u003eDie Benutzung des privaten Kraftfahrzeugs muss vor Reiseantritt unter Angabe der voraussichtlich zu fahrenden Kilometer, des Ziels der Reise und des Grundes durch den Vorgesetzten genehmigt werden.\u003c/li\u003e\r\n\u003cli\u003eVor Reiseantritt muss das Formular \u0026bdquo;Gruppenunfallversicherung\u0026ldquo; ausgef\u0026uuml;llt werden. Bei Sch\u0026auml;den am privaten oder am Dienst-Fahrzeug hat unverz\u0026uuml;glich eine Schadensmeldung an den Vorgesetzten zu erfolgen.\u003c/li\u003e\r\n\u003cli\u003eEventuelle Ersatzanspr\u0026uuml;che des Mitarbeiters k\u0026ouml;nnen nur im Rahmen der gesetzlichen Richtlinien und Bestimmungen anerkannt werden.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003eDienst-\u003cspan\u003ePKW\u003c/span\u003e\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eDer Einsatz von Dienst-\u003cspan\u003ePKW\u003c/span\u003e ist in der Nutzungsvereinbarung f\u0026uuml;r Firmenwagen geregelt.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003eParkgeb\u0026uuml;hren\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eFallen im Rahmen einer Gesch\u0026auml;ftsreise oder eines gesch\u0026auml;ftlichen Termins f\u0026uuml;r den Mietwagen, Dienst- oder Privat-\u003cspan\u003ePKW\u003c/span\u003e Parkgeb\u0026uuml;hren an, so d\u0026uuml;rfen diese nicht mehr als \u003cspan\u003eEUR\u003c/span\u003e 25,00 / 24 Stunden und \u003cspan\u003eEUR\u003c/span\u003e 50,00 pro Gesch\u0026auml;ftsreise betragen. H\u0026ouml;here Kosten werden nur im Ausnahmefall vom Manager oder im Headoffice vom direkten Vorgesetzten schriftlich genehmigt.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003ePark + Ride\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eWerden in der N\u0026auml;he von Haltestellen des \u0026ouml;ffentlichen Nahverkehrs Abstellm\u0026ouml;glichkeiten f\u0026uuml;r \u003cspan\u003ePKW\u003c/span\u003e zur Verf\u0026uuml;gung gestellt, so sind diese im Rahmen einer Gesch\u0026auml;ftsreise zu w\u0026auml;hlen. Ebenfalls sind verf\u0026uuml;gbare Park + Ride Services von Flugh\u0026auml;fen und DB-Bahnh\u0026ouml;fen zu nutzen.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003eCar und Bike Sharing / Limousinen Service\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eDie Nutzungsbedingungen des von Car und Bike Sharing oder Limousinen Services ergeben sich aus den jeweiligen Vertragsbedingungen des Anbieters. Motel One ist in bei der Nutzung dieser Anbieter nicht der Vertragspartner. Die Haftung liegt bei der nutzenden Person. Generell gilt: Bu\u0026szlig;gelder, geb\u0026uuml;hrenpflichtige Verwarnungen, Abschleppkosten etc. werden unabh\u0026auml;ngig davon, ob Car sowie Bike Sharing, Limousinen Services, Mietwagen, Privat-\u003cspan\u003ePKW\u003c/span\u003e oder Dienst-\u003cspan\u003ePKW\u003c/span\u003e genutzt wird, vom Arbeitgeber nicht erstattet.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003e\u0026Ouml;ffentliche Verkehrsmittel\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eEs ist vorgeschrieben, dass grunds\u0026auml;tzlich \u0026ouml;ffentliche Verkehrsmittel genutzt werden. Nur wenn diese nicht existieren oder begr\u0026uuml;ndbar nicht zumutbar sind, darf die jeweils kosteng\u0026uuml;nstigste Alternative (Taxi, Dienst-\u003cspan\u003ePKW\u003c/span\u003e, Privat-\u003cspan\u003ePKW\u003c/span\u003e oder Mietwagen) genutzt werden.\u003c/li\u003e\r\n\u003cli\u003eDie Gr\u0026uuml;nde f\u0026uuml;r die Unzumutbarkeit m\u0026uuml;ssen, wenn m\u0026ouml;glich, bereits im Vorwege mit dem Vorgesetzten abgestimmt und zur \u0026Uuml;berpr\u0026uuml;fung auf der Reisekostenabrechnung angegeben werden.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003eFlugreisen\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eDie Buchung von Flugreisen muss \u0026uuml;ber unser Vertragsreiseb\u0026uuml;ro erfolgen. Sollte der gebuchte Flug nicht ben\u0026ouml;tigt werden, muss dieser umgehend \u0026uuml;ber unseren Reiseb\u0026uuml;ropartner Intertours storniert oder umgebucht werden.\u003c/li\u003e\r\n\u003cli\u003eDie Buchungen der Flugtickets sind fr\u0026uuml;hestm\u0026ouml;glich vorzunehmen. Die besten Preise erh\u0026auml;lt man 60 bis 14 Tage vor dem Zeitpunkt des Fluges.\u003c/li\u003e\r\n\u003cli\u003eAufschl\u0026auml;ge f\u0026uuml;r aufzugebende Gep\u0026auml;ckst\u0026uuml;cke sind zu vermeiden. Geben Sie bei Buchung ausdr\u0026uuml;cklich an, ob Gep\u0026auml;ck aufgegeben werden soll. Eine Begr\u0026uuml;ndung hierf\u0026uuml;r ist nicht notwendig.\u003c/li\u003e\r\n\u003cli\u003eEine Nutzung des Flugzeugs ist nur zul\u0026auml;ssig, wenn dies zu einer erheblichen Zeit- und Kosteneinsparung f\u0026uuml;hrt und die Reisezeit mit dem schnellsten Alternativ-Reisemittel (z.B. Bahn oder Mietwagen) vier Stunden \u0026uuml;berschreitet oder wenn dienstliche Gr\u0026uuml;nde es im Einzelfall erfordern.\u003c/li\u003e\r\n\u003cli\u003eF\u0026uuml;r alle Fl\u0026uuml;ge muss das Best-Buy-Prinzip angewendet werden; das hei\u0026szlig;t, dass der g\u0026uuml;nstigste Tarif gebucht werden muss.\u003c/li\u003e\r\n\u003cli\u003eFl\u0026uuml;ge mit einem Wert von \u0026uuml;ber \u003cspan\u003eEUR\u003c/span\u003e 300,00 brutto f\u0026uuml;r Hin- und R\u0026uuml;ckflug inklusive Zusatzleistungen (Gep\u0026auml;ck, Sitzplatz, etc.), m\u0026uuml;ssen vor der Buchung durch den Vorgesetzten genehmigt werden.\u003c/li\u003e\r\n\u003cli\u003eNationale und innereurop\u0026auml;ische Flugreisen sind zum g\u0026uuml;nstigsten verf\u0026uuml;gbaren Flugpreis grunds\u0026auml;tzlich in der Economy Class zu buchen. Sie sind daher m\u0026ouml;glichst fr\u0026uuml;hzeitig zu planen.\u003c/li\u003e\r\n\u003cli\u003eBei Interkontinental-Reisen und au\u0026szlig;ereurop\u0026auml;ischen Fl\u0026uuml;gen kann ab einer Flugzeit von f\u0026uuml;nf Stunden die Benutzung der Business Class vor der Buchung durch den Vorgesetzten genehmigt werden. Warte- bzw. Umsteigezeiten sind bis zu einer Stunde, interkontinental bis zu drei Stunden, zumutbar, sofern hierdurch eine Kosteneinsparung von mindestens \u003cspan\u003eEUR\u003c/span\u003e 100,00, interkontinental von mindestens \u003cspan\u003eEUR\u003c/span\u003e 200,00 erzielt werden kann.\u003c/li\u003e\r\n\u003cli\u003eEs ist immer die preisg\u0026uuml;nstigste Variante zu w\u0026auml;hlen, auch wenn ein fr\u0026uuml;herer Abflugtermin in Kauf genommen werden muss. Bei gleichem Preisangebot der Fluggesellschaften ist mit unserem Partner Lufthansa / Star Alliance oder Air France zu fliegen.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003e\u003cstrong\u003ePr\u0026auml;mien Meilen \u0026amp; Punkte\u003c/strong\u003e\u003c/p\u003e\r\n\u003cul\u003e\r\n\u003cli\u003eDas Sammeln von Meilen oder Punkten ist von der Gesch\u0026auml;ftsf\u0026uuml;hrung geduldet. Es darf aber keinesfalls von den Reiseleitfaden abgewichen werden, um den Stand der jeweiligen Mitgliedschaft (z. B. Lufthansa Miles\u0026amp;More, Air Berlin Top Bonus, Bahnbonus, etc.) zu bevorteilen.\u003c/li\u003e\r\n\u003cli\u003ePr\u0026auml;mien, die im Rahmen des Arbeitsverh\u0026auml;ltnisses erworben wurden, stehen dem Arbeitgeber zu und sind nach M\u0026ouml;glichkeit f\u0026uuml;r Dienstreisen zu verwerten.\u003c/li\u003e\r\n\u003c/ul\u003e\r\n\u003cp\u003eWeitere Informationen zum Thema \u003ca href="https://www.myone.motel-one.com/de/wiki/buchhaltung/reisekosten/"\u003eReisekosten\u003c/a\u003e finden Sie im Bereich Buchhaltung.\u003c/p\u003e\r\n\u003cp\u003eBei Fragen oder Unklarheiten k\u0026ouml;nnen Sie sich jederzeit an \u003ca href="mailto:ukellenbach%40motel-one.com"\u003eHerrn Urs von Kellenbach\u003c/a\u003e oder unser Reiseb\u0026uuml;ro \u003ca href="mailto:info%40intertours.de"\u003eIntertours\u003c/a\u003e wenden.\u003cbr /\u003eTelefonisch erreichen Sie Intertours immer zu den Gesch\u0026auml;ftszeiten (08:30 \u0026ndash; 18:30 Uhr) unter 069/20747.\u003c/p\u003e\r\n\u003cp\u003eWir w\u0026uuml;nschen Ihnen immer eine gute und sichere Reise!\u003c/p\u003e\r\n\u003c/div\u003e\r\n\u003c/div\u003e',
                'publish_date': '2018-10-23 13:30:00',
                'author': {
                  'name': 'Arne Brodowski',
                  'avatar': '/api/v2/media/content/det/85/47/img104785.jpg',
                },
                'images': {
                  'title': {
                    'type': 'image/jpeg',
                    'link': '/api/v2/media/content/orig/64/99/img119964.jpg',
                  },
                  'slider': null,
                  'teaser': null,
                  'images': [],
                },
                'attachments': [
                  {
                    'type': 'image/jpeg',
                    'link': '/api/v2/media/content/orig/64/99/img119964.jpg',
                  },
                ],
              },
              {
                'id': 'page-13874',
                'title': 'Datenschutz bei Motel One',
                'teaser': 'Datenschutz ist ein wichtiger Bestandteil unserer Geschäftsphilosophie und als Wert fester Bestandteil der Motel One DNA.',
                'content': '\u003cdiv class="row module"\u003e\r\n\u003cdiv class="article-content"\u003e\r\n\u003cp\u003eMit jeder Buchung \u0026uuml;bermitteln uns unsere G\u0026auml;ste viele pers\u0026ouml;nliche Daten. Sie informieren uns \u0026uuml;ber ihren Namen, ihre Adresse, ihre Telefonnummer, ihre E-Mail-Adresse und die Details zu ihrem Zahlungsmittel.\u003c/p\u003e\r\n\u003cp\u003e\u003cstrong\u003eDiskretion ist daher oberstes Gebot f\u0026uuml;r unsere Arbeit.\u003c/strong\u003e\u003c/p\u003e\r\n\u003cp\u003eZus\u0026auml;tzlich zu unserem eigenen Anspruch, die pers\u0026ouml;nlichen und sensiblen Gastdaten zu sch\u0026uuml;tzen, sind wir verpflichtet, die geltenden Datenschutzgesetze einzuhalten.\u003c/p\u003e\r\n\u003cp\u003eIn Umsetzung der gesetzlichen Anforderungen hat die Motel One Group (d.h. die Motel One GmbH und s\u0026auml;mtliche verbundene Unternehmen i.S.d. \u0026sect; 15 AktG) unter anderem die in dieser Rubrik zusammengestellten Ma\u0026szlig;nahmen ergriffen, welche die Grundlage zum Umgang mit pers\u0026ouml;nlichen Daten der G\u0026auml;ste, Mitarbeiter und Gesch\u0026auml;ftspartner im Motel-One-Konzern bilden. Da diese Rubrik st\u0026auml;ndig aktualisiert wird, lohnt sich ein regelm\u0026auml;\u0026szlig;iger Besuch.\u003c/p\u003e\r\n\u003cp\u003eBei Fragen zum Thema Datenschutz k\u0026ouml;nnen Sie sich jederzeit an \u003ca href="mailto:privacy@motel-one.com"\u003eprivacy@motel-one.com\u003c/a\u003e wenden.\u003c/p\u003e\r\n\u003c/div\u003e\r\n\u003c/div\u003e',
                'publish_date': '2018-05-24 16:53:00',
                'author': {
                  'name': 'Arne Brodowski',
                  'avatar': '/api/v2/media/content/det/85/47/img104785.jpg',
                },
                'images': {
                  'title': {
                    'type': 'image/jpeg',
                    'link': '/api/v2/media/content/orig/71/5/img120571.jpg',
                  },
                  'slider': null,
                  'teaser': null,
                  'images': [],
                },
                'attachments': [
                  {
                    'type': 'image/jpeg',
                    'link': '/api/v2/media/content/orig/71/5/img120571.jpg',
                  },
                ],
              },
            ],
          },
        },
        streamWidgetData: {
          results: [],
          options: {
            groupId: 4616,
            title: 'Test2 Title',
          },
        },
      }
    },
  }
</script>
